import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dateToMonths' })
export class DateToMonthsPipe implements PipeTransform {

  /* transform(): Pipe que devuelve la cantidad de meses que hay entre un periodo
    date: Periodo con formato aaaa-mm
  */
  transform = (date: string): number => (Number(date.split("-")[0]) * 12) + Number(date.split("-")[1]);
  // ↑ Multiplica el año * 12 y lo suma a la cantidad de meses

}
